import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { RightOutlined } from '@ant-design/icons';
import styled from '@xstyled/styled-components';
import { Breadcrumb } from 'antd';
import { StyledHeadTitle } from '../components/text';
import { jsx as _jsx } from "react/jsx-runtime";
var BreadcrumbStyled = styled(Breadcrumb)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  li {\n    display: flex;\n    align-items: center;\n  }\n"])));
export var BreadcrumbComponent = function BreadcrumbComponent(props) {
  var parentFolders = props.parentFolders,
      onSelectFolderDetail = props.onSelectFolderDetail,
      translation = props.translation;
  return /*#__PURE__*/_jsx(BreadcrumbStyled, {
    separator: /*#__PURE__*/_jsx(RightOutlined, {}),
    children: parentFolders.map(function (folder) {
      return /*#__PURE__*/_jsx(Breadcrumb.Item, {
        onClick: function onClick() {
          return onSelectFolderDetail(folder.id);
        },
        children: /*#__PURE__*/_jsx(StyledHeadTitle, {
          children: translation(folder.title)
        })
      }, folder.id);
    })
  });
};